import {ActionCreator} from 'redux';
import {Dispatch, ThunkAction} from '../../../../../../../types/actions';
import { filterClickedSegmentEvent } from '../../../effects/segmentEvents';
import { ESegmentFilterTarget } from '../../../../../../../middlewares/segment/trackEntities/topBarEvents';

export const onSearchClicked: ActionCreator<ThunkAction> = (
    boardId: number
) => {
    const action = (
        dispatch: Dispatch,
    ) => {
        dispatch(filterClickedSegmentEvent(ESegmentFilterTarget.input, boardId));
    };
    return action;
};
